var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":function($event){$event.stopPropagation();_vm.showNextTx = !_vm.showNextTx}}},[_vm._v(_vm._s(_vm.showNextTx ? _vm.nextTx : _vm.durationText)+" "),_c('i',{staticClass:"las la-clock"})])
}
var staticRenderFns = []

export { render, staticRenderFns }